import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    _paq?: unknown[][];
  }
}

const MATOMO_SITE_ID = 7;
const MATOMO_TRACKER_URL = "/analytics/matomo.php";

function initMatomo() {
  if (window._paq) return;
  window._paq = window._paq || [];
  window._paq.push(["setTrackerUrl", MATOMO_TRACKER_URL]);
  window._paq.push(["setSiteId", MATOMO_SITE_ID]);
  window._paq.push(["enableLinkTracking"]);

  const script = document.createElement("script");
  script.async = true;
  script.src = "/analytics/matomo.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}

export function useMatomoTracking() {
  const location = useLocation();

  useEffect(() => {
    initMatomo();
  }, []);

  useEffect(() => {
    if (!window._paq) return;
    window._paq.push(["setCustomUrl", location.pathname + location.search]);
    window._paq.push(["setDocumentTitle", document.title]);
    window._paq.push(["trackPageView"]);
  }, [location.pathname, location.search]);
}
